import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ApiService from "../../../services/api";
import { Card, Col, Container, Row } from "react-bootstrap";
import "../css/compositions_page_category.css";
import { AuthContext } from "../../../services/auth";

const CompositionsPageCategory = () => {
  const { isEnglish } = useContext(AuthContext);
  const [compositions, setCompositions] = useState([]);
  const [Loading, setLoading] = useState(true);
  const { categoryCompositions } = useParams();

  const fetchCategoryCompositions = async () => {
    const Compositions = await ApiService.getAlbumsCategory(
      categoryCompositions.toUpperCase()
    );
    setCompositions(Compositions);
    setLoading(false);
  };

  useEffect(() => {
    fetchCategoryCompositions();
  }, []);

  if (Loading) {
    return;
  }

  return (
    <Container fluid className="m-0 padding_custom">
      <h2 className="mt-5 text-center section-title">
        {categoryCompositions.toUpperCase()}
      </h2>
      <div className="border-custom mt-3"></div>
      <Container fluid className="mt-5 p-0 container-color-compositions">
        <Container className="">
          <Row className="w-100 d-flex align-content-center justify-content-center m-0 py-5">
            {compositions.map((compositions) => {
              return (
                <Col
                  key={compositions.id}
                  className="text-center d-flex align-content-center justify-content-center my-3"
                >
                  {compositions.link && (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={
                        compositions.link.includes("https://")
                          ? compositions.link
                          : "https://" + compositions.link
                      }
                    >
                      <Card className="card-container-compositions">
                        <Card.Img
                          variant="top"
                          src={compositions.img}
                          className="img-compositions"
                        />
                      </Card>
                    </a>
                  )}
                  {!compositions.link && (
                    <Link
                      to={compositions.slug}
                      className=" text-decoration-none"
                    >
                      <Card className="card-container-compositions card-container-text w-100 h-100">
                        <Card.Img
                          variant="top"
                          src={compositions.img}
                          className="card-container-img-truck"
                        />
                        <Card.Body className="">
                          <Card.Title className="text_compositions">{compositions.title}</Card.Title>
                        </Card.Body>
                      </Card>
                    </Link>
                  )}
                </Col>
              );
            })}
          </Row>
        </Container>
      </Container>
    </Container>
  );
};
export default CompositionsPageCategory;
